const getQueryParamsString = (payload: Record<string, any> = {}) => {
  const params = new URLSearchParams();

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      params.append(key, String(value));
    }
  });

  return params.toString();
};

export { getQueryParamsString };
